import React from 'react';
import ReactDOM from 'react-dom';
import './styles/tokens.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// ============================================================
// Service Worker: forçar update e limpar caches antigos no boot
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Limpar todos os caches antigos
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          if (!name.includes('oxetech-v8')) {
            caches.delete(name);
          }
        });
      });
    }
    // Registrar SW com update forçado
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        registration.update();
        console.log('[SW] Registrado com sucesso:', registration.scope);
      })
      .catch((error) => {
        console.log('[SW] Falha no registro:', error);
      });
  });
}
